<template>
  <div class="carbonfootprint-certificate">
    <el-form
      v-for="(ruleForm, index) in formList"
      :ref="`ruleForm${index}`"
      :key="index"
      :model="ruleForm"
      :disabled="type === 'detail'"
      :rules="rules"
      size="small"
      label-width="110px"
      label-suffix=":"
    >
      <div class="certificate-title">
        <div class="certificate-title-text">碳足迹报告{{ index + 1 }}</div>
        <eui-btn
          v-if="formList.length > 1 && componentType != 'single'"
          type="text"
          color="#E50113"
          @click="deleteCertificate(index)"
          >删除</eui-btn
        >
      </div>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="报告出具机构" prop="institutionName">
            <el-input
              v-model="ruleForm.institutionName"
              maxlength="255"
              placeholder="请输入报告出具机构"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="报告编号" prop="reportCode">
            <el-input
              v-model="ruleForm.reportCode"
              maxlength="100"
              placeholder="请输入报告编号"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="18">
          <el-form-item label="认证物资类别" prop="certificateMaterialCategory">
            <certificateMaterialCategory
              :category="ruleForm.certificateMaterialCategory"
              @change="(value) => CategoryChange(value, index)"
            ></certificateMaterialCategory>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="产品名称" prop="productName">
            <el-input
              v-model="ruleForm.productName"
              maxlength="255"
              placeholder="请输入产品名称"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="规格型号" prop="specifications">
            <el-input
              v-model="ruleForm.specifications"
              maxlength="255"
              placeholder="请输入规格型号"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="系统边界" prop="systemBoundary">
            <el-select
              v-model="ruleForm.systemBoundary"
              placeholder="请选择系统边界"
              style="width: 100%"
            >
              <el-option label="摇篮到大门（Cradle-to-Gate）​" :value="1" />
              <el-option label="大门到大门（Gate-to-Gate）​" :value="2" />
              <el-option label="摇篮到坟墓（Cradle-to-Grave）" :value="3" />
              <el-option label="摇篮到摇篮（Cradle-to-Cradle）" :value="4" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item
            class="cursor-form-item"
            label="生命周期各阶段碳排放"
            :class="[...requireName]"
            :rules="[
              {
                required: true,
                validator: (rule, value, callback) =>
                  EmissionsValidator(rule, value, callback, index),
                trigger: 'blur',
              },
            ]"
            prop="carbonUnit"
          >
            <div>
              <el-radio v-model="ruleForm.carbonUnit" :label="1"
                >吨二氧化碳当量（tCO₂e）</el-radio
              >
              <el-radio v-model="ruleForm.carbonUnit" :label="2"
                >千克二氧化碳当量（kgCO₂e）</el-radio
              >
            </div>
            <lifecycle-emissions
              :emissions="ruleForm"
              @input="(data) => emissionsInput(data, index)"
            ></lifecycle-emissions>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-form-item label="碳足迹证书" prop="attachmentList">
          <eui-upload
            ref="upload"
            :headers="headers"
            :file-list="ruleForm.attachmentList"
            :action="fileUrl"
            :auto-upload="autoUpload"
            :show-file-list="true"
            :limit="1"
            accept=".pdf"
            text="上传文件"
            :limit-file-size="30"
            tip="最多上传1个文件，格式为PDF，大小不超过30M"
            @handleSuccess="(res) => uploadSuccess(res, index)"
          ></eui-upload>
        </el-form-item>
      </el-row>
    </el-form>
    <div v-if="componentType != 'single'" class="add-from">
      <eui-btn
        v-if="formList.length < 5"
        type="weak"
        icon="eicon-add"
        style="--width: 100%"
        size="40"
        icon-position="left"
        @click="addCertificate"
        >新增产品碳足迹报告</eui-btn
      >
    </div>
    <!-- <el-button @click="submit">提交</el-button> -->
  </div>
</template>

<script>
import { epecToken } from '@/modules/projectA/utils/globalData';
import api from '@/modules/projectA/api/order';
import certificateMaterialCategory from './certificateMaterialCategory.vue';
import lifecycleEmissions from './lifecycleEmissions.vue';

export default {
  name: 'CarbonfootprintCertificate',
  components: {
    certificateMaterialCategory,
    lifecycleEmissions,
  },
  props: {
    report: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      default: '',
    },
    componentType: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      headers: epecToken,
      fileUrl: api.fileUploadForGreenPdfAndPic,
      requireName: [],
      autoUpload: true,
      formList: [
        {
          institutionName: '',
          reportCode: '',
          carbonUnit: '',
          productName: '',
          certificateMaterialCategory: [],
          specifications: '',
          systemBoundary: '',
          lifeCarbonList: [
            { stageType: 1, carbonEmission: '', proportion: '' },
            { stageType: 2, carbonEmission: '', proportion: '' },
            { stageType: 3, carbonEmission: '', proportion: '' },
            { stageType: 4, carbonEmission: '', proportion: '' },
            { stageType: 5, carbonEmission: '', proportion: '' },
            { stageType: 6, carbonEmission: '', proportion: '' },
          ],
          carbonTotal: '',
          attachmentList: [],
        },
      ],
      rules: {
        institutionName: [
          { required: true, message: '请输入报告出具机构', trigger: 'blur' },
        ],
        reportCode: [
          { required: true, message: '请输入报告编号', trigger: 'blur' },
        ],
        systemBoundary: [
          { required: true, message: '请选择系统边界', trigger: 'change' },
        ],
        productName: [
          { required: true, message: '请输入产品名称', trigger: 'blur' },
        ],
        // Emissions: [{ validator: EmissionsValidator, trigger: 'blur' }],
      },
    };
  },
  computed: {
    mall_userInfo() {
      return this.$store.state.userInfo;
      // return this.$cookies.get("isLogin")
    },
  },
  created() {
    if (this.report && this.report.length > 0) {
      this.formList = JSON.parse(
        JSON.stringify(
          this.report.map((item) => {
            // if (item.carbonEmissionVOS)
            //   item.lifeCarbonList = item.carbonEmissionVOS;
            item.lifeCarbonList = item.lifeCarbonList || [
              { stageType: 1, carbonEmission: '', proportion: '' },
              { stageType: 2, carbonEmission: '', proportion: '' },
              { stageType: 3, carbonEmission: '', proportion: '' },
              { stageType: 4, carbonEmission: '', proportion: '' },
              { stageType: 5, carbonEmission: '', proportion: '' },
              { stageType: 6, carbonEmission: '', proportion: '' },
            ];
            if (item.categoryName)
              item.certificateMaterialCategory = [
                {
                  categoryName: item.categoryName,
                  categoryId: item.categoryId,
                },
              ];
            if (item.attachmentUrl)
              item.attachmentList = [
                { name: item.attachmentName, url: item.attachmentUrl },
              ];
            return item;
          })
        )
      );
    }
  },
  mounted() {},
  methods: {
    EmissionsValidator(rule, value, callback, index) {
      if (value) {
        const itemForm = this.formList[index];
        const { lifeCarbonList, carbonTotal } = itemForm;
        if (lifeCarbonList && lifeCarbonList.length > 0)
          lifeCarbonList.forEach((item) => {
            if (item.stageType === 3) {
              if (!item.carbonEmission) {
                if (this.requireName.indexOf('require2') === -1) {
                  // this.requireName.push('require2')
                  this.$set(this.requireName, 1, 'require2');
                  console.log(this.requireName);
                }

                callback(new Error('请输入生产阶段碳排放量'));
                return;
              }
              this.$set(this.requireName, 1, '');
            }
          });
        if (!carbonTotal) {
          // alert(123)
          if (this.requireName.indexOf('require4') == -1)
            this.$set(this.requireName, 3, 'require4');
          callback(new Error('请填写碳排放总量'));
          return;
        }
        this.$set(this.requireName, 3, '');

        callback();
        this.requireName = [];
      } else {
        callback(new Error('请选择碳排放单位'));
      }
      console.log(value, index);
    },
    uploadSuccess(res, index) {
      console.log(res);
      if (res.success) {
        this.formList[index].attachmentList = [
          {
            ...res.data,
            name: res.data.fileName,
            url: res.data.url,
          },
        ];
      }
    },
    deleteCertificate(index) {
      this.formList.splice(index, 1);
    },
    addCertificate() {
      this.formList.push({
        institutionName: '',
        reportCode: '',
        carbonUnit: '',
        certificateStandard: '',
        certificateStandardOther: '',
        productName: '',
        certificateMaterialCategory: [],
        specifications: '',
        systemBoundary: '',
        lifeCarbonList: [
          { stageType: 1, carbonEmission: '', proportion: '' },
          { stageType: 2, carbonEmission: '', proportion: '' },
          { stageType: 3, carbonEmission: '', proportion: '' },
          { stageType: 4, carbonEmission: '', proportion: '' },
          { stageType: 5, carbonEmission: '', proportion: '' },
          { stageType: 6, carbonEmission: '', proportion: '' },
        ],
        carbonTotal: '',
        attachmentList: [],
      });
    },
    CategoryChange(value, index) {
      this.formList[index].certificateMaterialCategory = value;
    },
    emissionsInput(data, index) {
      this.formList[index].lifeCarbonList = data.lifeCarbonList;
      this.formList[index].carbonTotal = data.carbonTotal;
    },
    submit() {
      return new Promise((resolve, reject) => {
        const validatePromises = this.formList.map((_, index) => {
          // 注意 v-for 下的 ref 是数组，所以要 [0]
          return this.$refs[`ruleForm${index}`][0].validate();
        });

        Promise.all(validatePromises)
          .then(() => {
            console.log('✅ 全部验证通过', this.formList);
            const params = this.getParams();
            // 这里写提交接口
            resolve({
              success: true,
              data: params,
            });
          })
          .catch(() => {
            reject();
            console.log('❌ 有表单没通过验证');
          }); // 把所有表单的 validate() 都转成 Promise
      });
    },
    getParams() {
      return this.formList.map((_) => {
        _.categoryName =
          _.certificateMaterialCategory &&
          _.certificateMaterialCategory[0] &&
          _.certificateMaterialCategory[0].categoryName;
        _.categoryId =
          _.certificateMaterialCategory &&
          _.certificateMaterialCategory[0] &&
          _.certificateMaterialCategory[0].categoryId;
        _.attachmentUrl =
          _.attachmentList && _.attachmentList[0] && _.attachmentList[0].url;
        _.attachmentName =
          _.attachmentList && _.attachmentList[0] && _.attachmentList[0].name;
        return _;
      });
    },
    save() {
      return this.getParams();
    },
  },
};
</script>

<style lang="scss" scoped>
.certificate-title {
  width: 100%;
  height: 34px;
  margin-bottom: 18px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(217, 217, 217, 1);
  .certificate-title-text {
    position: relative;
    font-size: 14px;
    line-height: 24px;
    font-family: PingFangSC-Medium;
    color: rgba(51, 51, 51, 1);
    padding-left: 10px;
    &::before {
      content: '';
      position: absolute;
      top: 0px;
      left: 0px;
      width: 80px;
      height: 24px;
      background: linear-gradient(
        90deg,
        rgba(102, 171, 254, 0.5) 0%,
        rgba(73, 151, 246, 0) 100%
      );
    }
  }
}
.add-from {
  margin-top: 10px;
}
::v-deep .el-form-item {
  .el-form-item__label {
    padding: 0px;
    padding-right: 10px;
    color: #666;
  }
  .el-form-item__label:after {
    content: '';
    display: none;
  }
}
::v-deep .el-form-item.cursor-form-item {
  .el-form-item__label {
    line-height: 1;
  }
}
::v-deep
  .el-form-item.is-required:not(.is-no-asterisk)
  .el-form-item__label-wrap
  > .el-form-item__label:before,
::v-deep
  .el-form-item.is-required:not(.is-no-asterisk)
  > .el-form-item__label:before {
  content: '*';
  color: rgba(240, 37, 15, 1);
  margin-right: 0px !important;
  /* margin-right: 4px; */
}
::v-deep .el-form .el-input__inner,
::v-deep .el-form .el-input,
::v-deep .el-form .el-date-editor,
::v-deep .el-form .el-select .el-input__inner,
::v-deep .el-form .el-select .el-input__inner,
::v-deep .el-input--small .el-input__inner {
  height: 30px !important;
  line-height: 30px !important;
}
::v-deep .el-radio {
  margin-right: 0px;
}
::v-deep .certificateStandardOther {
  padding-left: 0px !important;
}

::v-deep .el-form-item.is-error .lifecycle-emissions .el-input__inner {
  border-color: #dcdfe6 !important;
}

::v-deep
  .el-form-item.is-error.require2
  .lifecycle-emissions
  .require2
  .el-input__inner {
  border-color: #f56c6c !important;
}

::v-deep
  .el-form-item.is-error.require4
  .lifecycle-emissions
  .require4
  .el-input__inner {
  border-color: #f56c6c !important;
}

::v-deep .el-form-item.is-error .lifecycle-emissions {
  border-color: #f56c6c !important;
}
</style>
